import SearchPublic from '../components/SearchPublic'
import VideoModal from '../components/materials/VideoModal.vue'
import { createApp } from 'vue';
import { createPinia } from 'pinia';

const pinia = createPinia();

if(document.getElementById('search-container')){
    const app = createApp({
        components: {
            'search-results': SearchPublic
        }
    });

    app.use(pinia)

    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#search-container');
}

if(document.getElementById('search-video-modal-container')) {
    const app2 = createApp({
        components: {
            VideoModal
        }
    });

    // const pinia = createPinia();
    app2.use(pinia)

    app2.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app2.mount('#search-video-modal-container');
}